import * as React from "react";
import styled, { css } from "styled-components";
import { useCallback } from "react";
import Menu from "components/bootstrap/Menu";
import Icon from "components/common/Icon";
import usePerspectives from "components/perspectives/hooks/usePerspectives";
import useActivePerspective from "components/perspectives/hooks/useActivePerspective";
import useHistory from "routing/useHistory";
import ActivePerspectiveBrand from "./ActivePerspectiveBrand";
const CONTAINER_CLASS = "navbar-brand";
const Container = styled.span`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding-right: 0;
`;
const ItemContainer = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.large};
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
  `
);
const DropdownTrigger = styled.button`
  background: transparent;
  border: 0;
`;
const StyledMenuDropdown = styled(Menu.Dropdown)`
  z-index: 1032 !important;
`;
const DropdownIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
  `
);
const Switcher = () => {
  const { setActivePerspective } = useActivePerspective();
  const perspectives = usePerspectives();
  const history = useHistory();
  const onChangePerspective = useCallback(
    (nextPerspectiveId) => () => {
      const { welcomeRoute } = perspectives.find(({ id }) => id === nextPerspectiveId);
      history.push(welcomeRoute);
      setActivePerspective(nextPerspectiveId);
    },
    [history, perspectives, setActivePerspective]
  );
  return /* @__PURE__ */ React.createElement(Container, { className: CONTAINER_CLASS }, /* @__PURE__ */ React.createElement(Menu, { shadow: "md", withinPortal: true }, /* @__PURE__ */ React.createElement(ActivePerspectiveBrand, null, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(DropdownTrigger, { type: "button", title: "Change UI perspective" }, /* @__PURE__ */ React.createElement(DropdownIcon, { name: "arrow_drop_down" })))), /* @__PURE__ */ React.createElement(StyledMenuDropdown, null, perspectives.map(({ title, id }) => /* @__PURE__ */ React.createElement(Menu.Item, { key: id, onClick: onChangePerspective(id) }, /* @__PURE__ */ React.createElement(ItemContainer, null, title))))));
};
const PerspectivesSwitcher = () => {
  const perspectives = usePerspectives();
  if (perspectives.length === 1) {
    return /* @__PURE__ */ React.createElement(ActivePerspectiveBrand, { className: "navbar-brand" });
  }
  return /* @__PURE__ */ React.createElement(Switcher, null);
};
export default PerspectivesSwitcher;
